var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background"},[_c('birth-filters'),_c('births-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }